module.exports = __webpack_public_path__ + "img/08.6674ac0e.png";